function updateFormRecap() {
    document.querySelectorAll('[data-field]').forEach(span => {
        const fieldId = span.getAttribute('data-field');
        const input = document.getElementById(fieldId);
        if (input) {
            span.textContent = input.value || '';
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    updateFormRecap();
    
    // Listen for multiple events
    document.addEventListener('input', updateFormRecap);
    document.addEventListener('change', updateFormRecap);
    document.addEventListener('blur', updateFormRecap, true);
    
    // Also check periodically in case inputs are populated programmatically
    setInterval(updateFormRecap, 500);
});